// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1IIrk","description":"PatientConsentPreview_description__3P8av"};